import { lazy } from 'react';
import type { RouteObject } from 'react-router';

import { MainLayout } from '@/layout';

const routes: RouteObject[] = [
  {
    path: 'collection',
    Component: MainLayout,
    children: [
      {
        path: '',
        Component: lazy(() => import('@/page/collection/CollectionPage')),
      },
      {
        path: 'storage',
        Component: lazy(
          () => import('@/page/collection/LinkExternalStoragePage'),
        ),
      },
    ],
  },
];

export default routes;
